import React from "react";
import { Link } from "react-router-dom";
import Style from '../styles/Footer.module.css';
import logo from '../imgs/logoImg.png';
import award from '../imgs/awardLogo.png';
import faceIcon from '../imgs/homePage/facebookIcon.svg';
import instaIcon from '../imgs/homePage/instaIcon.svg';
import tiktokIcon from '../imgs/homePage/tiktokIcon.svg';

const Footer= () =>{
    return (
        <footer className={Style.Footer}>
            <div className={Style.FooterContent}>
                <div className={Style.PartA}>
                    <div className={Style.LogoFooter}>
                        <img className={Style.bannerLogo} src={logo} alt="Dino Construction" loading="lazy" decoding="async" width="210" height="92"></img>
                        <img className={Style.awardLogo} src={award} alt="NextDoor 2023 Award" loading="lazy" decoding="async" width="120" height="120"></img>
                    </div>
                    <p>Reliable construction and renovation work for homeowners across Asheville and the surrounding area.</p>
                    <Link className={Style.FooterCta} to='/ContactUs#Estimate'>Request a Quote</Link>
                </div>

                <div className={Style.FooterColumn}>
                    <h3>Services</h3>
                    <Link to='/Concrete'>Concrete</Link>
                    <Link to='/Roofing'>Roofing</Link>
                    <Link to='/Porches-Decks-Fences'>Decks and Fences</Link>
                    <Link to='/Paint'>Painting</Link>
                    <Link to='/StonePatio'>Stone Patios</Link>
                    <Link to='/BlockFoundation'>Block Foundations</Link>
                </div>

                <div className={Style.PartB}>
                    <div className={Style.ContactContent}>
                        <h3>Contact</h3>
                        <p><strong>Phone</strong><a href="tel:828-702-8101">(828) 702-8101</a></p>
                        <p><strong>Phone</strong><a href="tel:828-206-4457">(828) 206-4457</a></p>
                        <p><strong>Email</strong><a href="mailto:Dino@DinoConstructions.com">Dino@DinoConstructions.com</a></p>
                    </div>
                    <div className={Style.FollowContent}>
                        <h3>Follow</h3>
                        <div className={Style.IconContent}>
                            <a href="https://www.facebook.com/profile.php?id=100054311676877" aria-label="Facebook"><img src={faceIcon} alt="" width="22" height="22"/></a>
                            <a href="https://www.instagram.com/dino_castillo/" aria-label="Instagram"><img src={instaIcon} alt="" width="22" height="22"/></a>
                            <a href="https://www.tiktok.com/@dinocastill" aria-label="TikTok"><img src={tiktokIcon} alt="" width="22" height="22"/></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={Style.HorizontalLn}></div>
            <div className={Style.Copyright}>
                <p>Copyright © 2026 Dino Construction. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
